import React, { ReactElement } from 'react';
import './index.scss';
import { Divider, useWindowSize } from '@telefonica/mistica';

export const SkeletonMobile: React.FC<ISkeletonMobile> = ({ header, body }) => {
    const size = useWindowSize();
    return (
        <div className='skeleton'>
            <div className='skeleton__header'>
                <div className='skeleton__header-date'>
                    {header}
                    {size?.width >= 1024 && <Divider />}
                </div>
                <div className='skeleton__body'>{body}</div>
            </div>
        </div>
    );
};
export default SkeletonMobile;

type ISkeletonMobile = {
    header: ReactElement;
    body: ReactElement;
};
